import React from 'react';
import './EncryptionBanner.css';

interface EncryptionBannerProps {
  recipientName?: string;
}

const EncryptionBanner: React.FC<EncryptionBannerProps> = ({ recipientName }) => {
  return (
    <div className="encryption-banner">
      <svg 
        className="encryption-banner__icon" 
        width="14" 
        height="14" 
        viewBox="0 0 24 24" 
        fill="currentColor"
      >
        <path d="M12 1C9.24 1 7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3zm0 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"/>
      </svg>
      <span className="encryption-banner__text">
        {recipientName 
          ? `End-to-end encrypted. Only you and ${recipientName} can read these messages.`
          : 'Messages are end-to-end encrypted'
        }
      </span>
    </div>
  );
};

export default EncryptionBanner;
